module.exports = __webpack_public_path__ + "static/media/cooking1.64d9b7c0.png";